import React from 'react'

// material ui
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'

// containers
import ErrorMessage from 'components/shared/ErrorMessage'

// atomic components
import Loading from 'components/atoms/Loading'

// local components
import Overview from './Overview'

const UI = props => {
  const { loading, account } = props

  return (
    <Container maxWidth='md'>
      <Box mt={2}>
        <ErrorMessage />
      </Box>
      {!account || loading ? <Loading /> : <Overview {...props} />}
    </Container>
  )
}

export default UI
